import { Paper } from "@mui/material"
import { RegimeSearchScopeSelection } from "routes/regime/plugins/regime-search/regime-search-scope-selection.js"

export function RegimeSearchResultsPanel({ children, ...props }) {
    return (
        <Paper {...props}>
            <RegimeSearchScopeSelection />
            {children}
        </Paper>
    )
}
